import _ from 'lodash';
import { formatWord } from 'utils/helperMethods';

export function bubbleChartElasticityComparisionParser(data: any, group: any) {
    let FormattedData = data.map((item: any) => {
        let tempObj: any = {};
        tempObj['tactics'] = item.groupBy;
        tempObj['name'] = item.groupBy;
        item.kpisData.forEach((kpi: any) => {
            tempObj[kpi.kpiName] =
                typeof kpi.kpiValue === 'number'
                    ? kpi?.kpiName === 'bpe'
                        ? Math.abs(_.round(kpi.kpiValue, 2))
                        : _.round(kpi.kpiValue, 2)
                    : kpi.kpiValue;
        });
        tempObj[`group`] = formatWord(group);
        return tempObj;
    });
    return FormattedData;
}
